module.exports = __webpack_public_path__ + "static/media/growmind 2.8539f650.png";